import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchGet } from '../../api/common';
import './styles.css';
import { Box, Container, Stack, Typography } from '@mui/material';

export const Unsubscribe = () => {
  const { token } = useParams();

  useEffect(() => {
    const unsubscribe = async () => {
      const res = await fetchGet(`/authenticate/unsubscribe/${token}`);
      if (res && res.message === 'Unsubscribe successful' && res.user) {
        console.log('successfully unsubbed');
      } else {
        console.log('error with unsubscribe');
      }
    };
    unsubscribe();
  }, []);

  return (
    <Container
      sx={{
        height: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack>
        <Typography>You have been unsubscribed from all PAR emails</Typography>
      </Stack>
    </Container>
  );
};
